<template>
  <div>
      <h5>ประกาศความเป็นส่วนตัว</h5>
      <p>ท่านจะต้องมีอายุไม่ตำ่กว่า 16 ปีเพื่อเข้าร่วมกิจกรรมนี้</p>
      <div class="pa-2" style="height: 200px; overflow-y: auto; border: 1px solid #ccc;">
        <p>
          Kerastase จะดำเนินการประมวลผลข้อมูลส่วนบุคคลของท่าน ซึ่งรวมถึง ชื่อ-นามสกุล เบอร์ติดต่อ ของท่านเพื่อ วัตถุประสงค์ในการทำการตลาดแบบ retargeting โดย Kerastase จะจัดเก็บข้อมูลส่วนบุคคลของท่านภายในระยะเวลาที่จำเป็นตามวัตถุประสงค์ข้างต้นเท่านั้น เว้นแต่มีความจำเป็นอื่นใดตามกฎหมาย
        </p>
        <p>
          ท่านสามารถศึกษาข้อมูลเพิ่มเติมเกี่ยวกับการใช้ข้อมูลส่วนบุคคลของท่านได้ที่ นโยบายความเป็นส่วนตัว ของเรา หรือติดต่อผ่านทาง THDPO@loreal.com ในกรณีที่ท่านมีข้อสงสัยหรือต้องการใช้สิทธิทางกฎหมายเพิ่มเติม
        </p>
        <p>
          ทั้งนี้ Kerastase อาจแบ่งปันข้อมูลส่วนบุคคลของท่านแก่คู่ค้าหรือผู้รับจ้างในการช่วยเก็บรวบรวมและ/หรือประมวลผลข้อมูลเพื่อวัตถุประสงค์ดังกล่าวข้างต้นเท่านั้น  Kerastase แบรนด์ภายใต้การดูแลของ บริษัท ลอรีอัล (ประเทศไทย) จำกัด นโยบายข้อมูลส่วนบุคคล
        </p>
        <a href="https://www.loreal.com/en/thailand/pages/group/privacy-policy-thailand-th/">https://www.loreal.com/en/thailand/pages/group/privacy-policy-thailand-th/</a>
      </div>
      <div class="mt-2" style="border: 1px solid #ccc;">
        <div class="d-flex justify-start align-center">
          <div class="d-flex align-center pa-1 ma-1">
            <v-checkbox
            :on-icon="'mdi-check-circle'"
            :off-icon="'mdi-checkbox-blank-circle-outline'"
            v-model="statusPAPA"
            false-value="ไม่ยินยอม"
            true-value="ยินยอม"
            ></v-checkbox>
          </div>
          <div class="d-flex flex-column my-2">
            <div>ยินยอม</div>
            <p class="ma-0" style="font-size: 11px;">ข้าพเจ้าตกลงและยินยอมตาม ข้อกำหนดและเงื่อนไข ของกิจกรรมนี้*</p>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  props: {
    fieldValue: {
      type: String,
      default: 'ไม่ยินยอม'
    }
  },
  data () {
    return {
      statusPAPA: this.fieldValue || 'ไม่ยินยอม'
    }
  },
  watch: {
    fieldValue (newVal) {
      this.statusPAPA = newVal || 'ไม่ยินยอม'
    },
    statusPAPA (newVal) {
      console.log('------newVal', newVal)
      this.$emit('change', newVal) // ส่งขึ้นไปหาแม่
    }
  },
  async mounted () {
    if (this.statusPAPA) {
      this.statusPAPA = 'ไม่ยินยอม'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Events/PADAFixShopEvent.vue